import { render, staticRenderFns } from "./PropertyStatusBadgeComponent.vue?vue&type=template&id=515cd643"
import script from "./PropertyStatusBadgeComponent.vue?vue&type=script&lang=js"
export * from "./PropertyStatusBadgeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports